export class ServiceCall {
  public id: number;
  public customer: string;
  public customerShortName: string;
  public siteId: string;
  public location: string;
  public locationShortName: string;
  public creationTime: string;
  public followup: Array<number>;
  public status: number;
  public remarks: string;
  public teamIds: Array<number>;
  public teamListModel: Array<any>;
  public contactPerson: string;
  public contactNumber: string;
  public contactEmail: string;
  public receivedTime: string;
  public arrivedTime: string;
  public completedTime: string;
  public tentativeBeginDate: string;
  public tentativeFinishDate: string;
  public serviceBeginDate: string;
  public serviceFinishDate: string;
  public customerId: number;
  public pmServiceId: number;
  public ecallId: number;
  public relatedServiceCallId: number;
  public schedule: string;
  public userArrayModels: Array<any>;
  public customerReport: string;
  constructor (
    id = 0,
    customer = '',
    customerShortName = '',
    siteId = '',
    location = '',
    locationShortName = '',
    creationTime = '',
    followup = [],
    status = 999,
    remarks = '',
    teamIds = [],
    teamListModel = [],
    contactPerson = '',
    contactNumber = '',
    contactEmail = '',
    receivedTime = '',
    arrivedTime = '',
    completedTime = '',
    tentativeBeginDate = '',
    tentativeFinishDate = '',
    serviceBeginDate = '',
    serviceFinishDate = '',
    customerId = 0,
    pmServiceId = null,
    ecallId = null,
    relatedServiceCallId = null,
    schedule = '',
    userArrayModels = [],
    customerReport = null,
  ) {}
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/model/service-call.ts